import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* updateEmail(action) {
  let response = null;
  const showGeneralPopup = false;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_UPDATE_EMAIL,
      API.POST,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.UPDATE_EMAIL_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.UPDATE_EMAIL_FAILED, error: response });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.UPDATE_EMAIL_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* stopReceiveNotifications(action) {
  let response = null;
  const showGeneralPopup = false;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_STOP_RECEIVE_NOTIFICATION,
      API.POST,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.STOP_RECEIVE_NOTIFICATIONS_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.STOP_RECEIVE_NOTIFICATIONS_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.STOP_RECEIVE_NOTIFICATIONS_FAILED, error });
  }
  store.dispatch(hideLoading());
}

function* getStopReceiveNotifications(action) {
  let response = null;
  const showGeneralPopup = false;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_GET_STOP_NOTIFICATION_CATEGORIES,
      API.GET,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_STOP_NOTIFICATION_CATEGORIES_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.GET_STOP_NOTIFICATION_CATEGORIES_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({
      type: types.GET_STOP_NOTIFICATION_CATEGORIES_FAILED,
      error
    });
  }
  store.dispatch(hideLoading());
}

export function* watchGetStopReceiveNotifications() {
  yield takeLatest(
    types.GET_STOP_NOTIFICATION_CATEGORIES_REQUESTED,
    getStopReceiveNotifications
  );
}

export function* watchStopReceiveNotifications() {
  yield takeLatest(
    types.STOP_RECEIVE_NOTIFICATIONS_REQUESTED,
    stopReceiveNotifications
  );
}

export function* watchUpdateEmail() {
  yield takeLatest(types.UPDATE_EMAIL_REQUESTED, updateEmail);
}
